<script setup lang="ts">
import { GpNavigationItem, GpNavigationItemLink } from '@gportal/uikit';

withDefaults(
  defineProps<{
    href: string;
    icon?: string[] | object;
    label?: string;
    target?: '_blank' | '_parent' | '_self' | '_top';
  }>(),
  {
    label: '',
    icon: null,
    target: '_self',
  },
);

// XXX: Maybe mark external links as such with an indicator icon? See Component.ExternalLink.vue
// for an example.
</script>

<template>
  <GpNavigationItem>
    <GpNavigationItemLink
      class="tw-text-gp-mouse hover:tw-text-gp-mouse-light"
      :href="href"
      :icon="icon"
      :label="label"
      :target="target"
    />
  </GpNavigationItem>
</template>
